module.exports = __webpack_public_path__ + "img/logoGenerico.594c7bef.png";